import React from 'react';

const SVG = ({ width = '100%', viewBox = '0 0 166 166' }) => (
  <svg width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g stroke="silver">
      <defs>
        <radialGradient id="dot-gradient" cx="40%" cy="40%" r="80%">
          <stop offset="0%" stopColor="lime" />
          <stop offset="100%" stopColor="darkslategray" />
        </radialGradient>
      </defs>
      <rect width="166" height="166" fill="none" stroke="none" />
      <rect x="35" y="35" width="48" height="48" fill="rgb(100,100,255)" />
      <circle cx="59" cy="59" r="7" fill="none" stroke="black" strokeWidth="4" />

      <rect x="35" y="83" width="48" height="48" fill="rgb(255,100,100)" />
      <rect x="58" y="98" width="4" height="18" fill="black" stroke="none" />

      <rect x="83" y="83" width="48" height="48" fill="rgb(100,255,100)" />
      <rect x="100" y="100" width="14" height="14" stroke="black" strokeWidth="4" fill="none" />

      <path d="M0,35 H166 M0,83 H166 M0,131 H166 M35,0 V166 M83,0 V166 M131,0 V166" />
      <circle cx="83" cy="83" r="7" fill="black" stroke="none" />
      <circle cx="83" cy="83" r="6" fill="url(#dot-gradient)" stroke="none" />
    </g>
  </svg>
);

export default SVG;
